module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-917-min.f3574105.jpg";